export const EntitlementsAccess = {
  OVERVIEW: 'access:::overview',
  ANALYTICS: 'access:::analytics',
  CHURN: 'access:::churn',
  INTEGRATION: 'access:::integration',
  GAME_ADJUSTMENTS: 'access:::game_adjustments',
  GAME_COLLECTION: 'access:::game_collections',
  GAME_RECS: 'access:::game_recs',
  INTEGRATION_GUIDE: 'access:::integration_guide',
  COST_OPTIMIZATION: 'access:::cost_optimization',
  PRIORITY_IMPACT: 'access:::cost_optimization_analytics',
} as const;
